module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('partial-loader', {
    attrs: {
      "loading": _vm.isFetching
    }
  })], 1), _vm._v(" "), (!_vm.isFetching) ? _c('div', {
    staticClass: "col-12"
  }, [(_vm.error) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('b-jumbotron', {
    staticClass: "mb-3 p-4"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h1', {
    staticClass: "display-3"
  }, [_vm._v("Veiling activiteit")]), _vm._v(" "), (_vm.person) ? _c('div', [_c('person-info', {
    attrs: {
      "person": _vm.person
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('b-button-group', {
    staticClass: "pull-right"
  }, [_c('b-button', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.hover",
      modifiers: {
        "hover": true
      }
    }],
    attrs: {
      "to": _vm.goBack(),
      "exact": "",
      "title": "Terug",
      "variant": "outline-secondary"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-reply"
  })])], 1)], 1)])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row mb-3"
  }, [_c('div', {
    staticClass: "col-lg-12 col-xl-6"
  }, [_c('b-jumbotron', {
    staticClass: "mb-3 p-4 h-100"
  }, [_c('seller-cost')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12 col-xl-6"
  }, [_c('b-jumbotron', {
    staticClass: "mb-3 p-4 h-100"
  }, [_c('item-list')], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbaa9a86"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Seller/Seller.vue
// module id = 1348
// module chunks = 1